<script lang="ts">

import PageLayout from "$lib/components/PageLayout.svelte";
import {Button, Card, Heading, Hr, Input, Label} from "flowbite-svelte";
import AsyncTypeAhead from "$lib/components/AsyncTypeAhead.svelte";
import {extendContract, listEmployees} from "$lib/calls/employee";
import dayjs from "dayjs";
import {get} from "$lib/api";
import Sleep from "$lib/utils/sleep";
import {asValue} from "$lib/utils/lenkradDate.js";

let employees = [];
let inputValue = '';

const call = async value => {
    return await listEmployees('page=1&pageSize=10&search=' + value)
}
const extract = async (item) => {
    if(employees.length > 29){
        alert('Max. 30')
        return
    }
    inputValue = 'asdfasedef';
    employees = [...employees, await get('/employee/' + item.uuid)]
}

let newEndDate = dayjs().add(6, 'month').format('YYYY-MM-DD')

const process = async () => {
    for(let i = 0; i < employees.length; i++){
        const employee = employees[i];
        const prolongingContract = employee.contracts.find(contract => {
            return contract.employmentContractStatus === 'synchronized' && dayjs(asValue(contract.endDate)).isAfter(dayjs());
        });
        if(!prolongingContract){
            employees[i].batchStatus = 'Kein Vertrag verlängbar';
        } else {
            prolongingContract.newEndDate = newEndDate;
            const result = await extendContract(employee.uuid, prolongingContract);
            employees[i].batchStatus = 'Vertrag erstellt...';
            await get('/render-contract/'+employee.id)
            employees[i].batchStatus = 'Signaturauftrag erstellt und versendet';
        }
        await Sleep(400)
    }


}


</script>
<PageLayout path="settings/batch">
    <Heading class="text-neutral-500 mb-3" tag="h3">Vertragsverlängerungen</Heading>

    <div class="grid grid-cols-3 gap-3">
        <div class="col-span-2">
            <div class="mb-12">
                {#each employees as employee}
                    <div class="flex gap-3 mt-5 border-b pb-3">
                        <div class="flex-1">{employee.name}</div>
                        <div class="pr-5">
                            Status: {employee?.batchStatus || '-'}
                        </div>
                        {#if !employee.batchStatus}
                            <div>
                                <Button on:click={() => employees = employees.filter(e => e !== employee)} size="xs" color="red">entfernen</Button>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
        <Card class="min-w-full">
            <Label for="date" class="space-y-2 mb-3">
                <span>Neues Enddatum</span>
                <Input size="sm" id="date" type="date" bind:value={newEndDate} placeholder="Neues Enddatum"/>
            </Label>
            <AsyncTypeAhead bind:value={inputValue} label="Mitarbeiter suchen" {call} {extract}/>

        </Card>
    </div>

    {#if employees.length > 0}
        <Hr/>
        <div class="flex gap-5 justify-between">
            <div class="grid place-content-end">
                <Button color="red" on:click={() => employees = []}>Alle entfernen</Button>
            </div>

            <div class="grid place-content-end">
                <Button on:click={process}>Verträge verlängern</Button>
            </div>
        </div>

    {/if}


</PageLayout>